import React from "react";

/* ─── Set d'icônes SVG partagé — Navbar, drawer, BottomNavBar ───────────── */
export default function NavIcon({ name, size = 18, color = "currentColor", strokeWidth = 1.8 }) {
  const common = { width: size, height: size, viewBox: "0 0 24 24", fill: "none" };

  switch (name) {
    case "howto": // ampoule "Comment ça marche"
      return (
        <svg {...common}>
          <path d="M9 18h6M10 21h4" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
          <path d="M12 3a6 6 0 0 0-3.5 10.9c.4.3.6.8.6 1.3V16h5.8v-.8c0-.5.2-1 .6-1.3A6 6 0 0 0 12 3z" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" />
        </svg>
      );
    case "markets": // bar chart (version exacte BottomNavBar, avec lignes de fond)
      return (
        <svg {...common}>
          <path d="M4 19V13M10 19V9M16 19V5M22 19v3" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" transform="translate(0,-3)" />
          <rect x="3" y="16" width="3" height="5" rx="1" fill="none" stroke={color} strokeWidth={strokeWidth} />
          <rect x="9" y="11" width="3" height="10" rx="1" fill="none" stroke={color} strokeWidth={strokeWidth} />
          <rect x="15" y="7" width="3" height="14" rx="1" fill="none" stroke={color} strokeWidth={strokeWidth} />
        </svg>
      );
    case "positions": // trending up (style BottomNavBar)
      return (
        <svg {...common}>
          <path d="M3 17l5-6 4 3 6-8" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M14 6h5v5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "wallet": // (style BottomNavBar)
      return (
        <svg {...common}>
          <rect x="3" y="6" width="18" height="13" rx="2.5" stroke={color} strokeWidth={strokeWidth} fill="none" />
          <path d="M16 12.5h2.5" stroke={color} strokeWidth={strokeWidth + 0.2} strokeLinecap="round" />
          <path d="M3 9.5h18" stroke={color} strokeWidth={strokeWidth * 0.9} />
        </svg>
      );
    case "support": // headset (style BottomNavBar)
      return (
        <svg {...common}>
          <path d="M4 13a8 8 0 0 1 16 0" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
          <rect x="3" y="13" width="4" height="6" rx="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
          <rect x="17" y="13" width="4" height="6" rx="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
        </svg>
      );
    case "employee": // headset + badge (réutilise support)
      return (
        <svg {...common}>
          <path d="M4 13a8 8 0 0 1 16 0" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
          <rect x="3" y="13" width="4" height="6" rx="2" stroke={color} strokeWidth={strokeWidth} />
          <rect x="17" y="13" width="4" height="6" rx="2" stroke={color} strokeWidth={strokeWidth} />
          <circle cx="12" cy="6" r="1.4" fill={color} />
        </svg>
      );
    case "admin": // gear
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3" stroke={color} strokeWidth={strokeWidth} />
          <path
            d="M19.4 13a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V19a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 9 17.35a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.64 13a1.7 1.7 0 0 0-1.56-1.04H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.65 9a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.65a1.7 1.7 0 0 0 1.04-1.56V3a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15.35 4.65a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.35 9a1.7 1.7 0 0 0 1.56 1.04H21a2 2 0 1 1 0 4h-.09A1.7 1.7 0 0 0 19.4 13z"
            stroke={color} strokeWidth={strokeWidth * 0.85} strokeLinejoin="round"
          />
        </svg>
      );
    case "settings": // gear (alias, smaller weight ok via same path)
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3" stroke={color} strokeWidth={strokeWidth} />
          <path
            d="M19.4 13a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V19a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 9 17.35a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.64 13a1.7 1.7 0 0 0-1.56-1.04H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.65 9a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.65a1.7 1.7 0 0 0 1.04-1.56V3a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15.35 4.65a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.35 9a1.7 1.7 0 0 0 1.56 1.04H21a2 2 0 1 1 0 4h-.09A1.7 1.7 0 0 0 19.4 13z"
            stroke={color} strokeWidth={strokeWidth * 0.85} strokeLinejoin="round"
          />
        </svg>
      );
    case "legal": // document
      return (
        <svg {...common}>
          <path d="M7 3h7l4 4v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" />
          <path d="M14 3v4h4" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" />
          <path d="M9 12h6M9 16h6" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
      );
    case "company": // building
      return (
        <svg {...common}>
          <rect x="4" y="9" width="7" height="12" stroke={color} strokeWidth={strokeWidth} />
          <rect x="13" y="3" width="7" height="18" stroke={color} strokeWidth={strokeWidth} />
          <path d="M6.5 12h2M6.5 15h2M6.5 18h2M15.5 6h2M15.5 9h2M15.5 12h2M15.5 15h2" stroke={color} strokeWidth={strokeWidth * 0.85} strokeLinecap="round" />
        </svg>
      );
    case "resources": // bookshelf
      return (
        <svg {...common}>
          <path d="M4 4v17M9 4v17M14 4v17M19 4v17" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
          <path d="M4 4h5M9 4h5M14 4h5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
      );
    case "faq": // question mark in circle
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" stroke={color} strokeWidth={strokeWidth} />
          <path d="M9.5 9.3a2.5 2.5 0 1 1 3.6 2.6c-.6.4-1.1.8-1.1 1.6v.3" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="12" cy="17" r="0.9" fill={color} />
        </svg>
      );
    case "menu": // hamburger (style BottomNavBar)
      return (
        <svg {...common}>
          <path d="M4 6h16M4 12h16M4 18h16" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
      );
    case "close":
      return (
        <svg {...common}>
          <path d="M5 5l14 14M19 5L5 19" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
      );
    case "lock": // (style BottomNavBar)
      return (
        <svg {...common}>
          <rect x="5" y="11" width="14" height="10" rx="2" stroke={color} strokeWidth={strokeWidth + 0.2} fill="none" />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke={color} strokeWidth={strokeWidth + 0.2} strokeLinecap="round" fill="none" />
        </svg>
      );
    case "sun":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="4" stroke={color} strokeWidth={strokeWidth} />
          <path d="M12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
      );
    case "moon":
      return (
        <svg {...common}>
          <path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5z" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" />
        </svg>
      );
    case "bell": // cloche — centre de notifications
      return (
        <svg {...common}>
          <path d="M6 8a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9.5 20a2.5 2.5 0 0 0 5 0" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
      );
    case "logout":
      return (
        <svg {...common}>
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M16 17l5-5-5-5M21 12H9" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    default:
      return null;
  }
}
